export const storeProducts = [
  {
    id: 1,
    title: "CLIP SUPER TUNER ",
    img: "img/product-1.png",
    price: 100,
    company: "GOOGLE",
    info:
      "CLIP IT SUPER TUNER - Digital Auto Clip-On Chromatic Tuner. 2 colour LCD display. 430-450Hz and flat tuning b, bb. Tunes Chromatic, Guitar, Bass, Violin, Ukulele C & D. Built in piezo sensor for accurate tuning. Auto tuning range A0 to C8. Auto off. CR2032 battery included. Full colour display packaging. Black. Also available in display carton of 10 units.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Pickboy Tuner",
    img: "img/product-2.png",
    price: 80,
    company: "Pickboy",
    info:
      "Our Pickboy clip tuner is quick and responsive all the way down to your low B string. Blue background with simulated white tuning needle that turns green when at pitch. Attractive design and easy operation",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "T2 SMART TUNER",
    img: "img/product-3.png",
    price: 200,
    company: "JOWOOM",
    info:
      "FULL AUTOMATIC TUNER FOR GUITAR & UKULELE. Put the guitar head machine into the T2 Smart Guitar Tuner and bounce it back. The T2 smart tuner takes care of the rest. Now, just concentrate on playing your guitar.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Boss Waza Craft",
    img: "img/product-4.png",
    price: 350,
    company: "Boss",
    info:
      "Part of Boss’ Waza Craft series, the Boss CE-2W is a fantastic option for anyone who wants to make a beeline for the classic chorus tones of the 80s. The CE-2W allows players to summon the circuits of the original CE-2 and CE-1 chorus pedals, and also features a vintage vibrato mode.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: " Maxon PhaseTone",
    img: "img/product-5.png",
    price: 350,
    company: "Maxon",
    info:
      "Maxon PT-999 Phase Tone phase shifter guitar effect pedal. Does not include power supply.  840433000174",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Guitar Strings",
    img: "img/product-6.png",
    price: 120,
    company: "Nicola",
    info:
      "Nicola Phosphor Bronze Acoustic Guitar Strings. A family owned and operated business, Nicola Strings are handcrafted, inspected, and packaged to assure the tone, feel, and quality that every musician deserves.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Nylon Strings",
    img: "img/product-7.png",
    price: 30,
    company: "ZIKO",
    info:
      "Hgh quiality color nylon guitar string color silly string classical guitar strings with affordable price",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "R.Krieger Pick Set",
    img: "img/product-8.png",
    price: 30,
    company: "Dunlop",
    info:
      "Set of 4 pearloid/celluloid medium gauge guitar picks; The Doors logo printed on front, Robby Krieger signature printed on back.",
    inCart: false,
    count: 0,
    total: 0
  },

    {
    id: 9,
    title: "Capo Bronze",
    img: "img/product-9.png",
    price: 30,
    company: "Dunlop",
    info:
      "Ernie Ball Axis Capo Dual Radius Guitar Capo Bronze 9602. The Ernie Ball Axis Capo’s ergonomic features allow for fast and accurate single-handed key changes. A dual-radius design conforms to flat or curved fretboards, ensuring buzz-free operation on 6 or 7 string electric and acoustic guitars.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.png",
  price: 10,
  company: "google",
  info:
    "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0
};



// WEBPACK FOOTER //
// ./src/data.js